"use client";

import { useMixpanel } from "@/hooks/mixpanel/use-mixpanel";

export const useYoutubeTracking = () => {
  const { track } = useMixpanel();

  const trackDownloadSuccess = (fileName: string) => {
    track("YouTube Download Success", {
      file_name: fileName,
      category: "youtube",
    });
  };

  const trackDownloadError = (errorType: string, videoUrl: string) => {
    track("YouTube Download Error", {
      error_type: errorType,
      video_url: videoUrl,
      category: "youtube",
    });
  };

  return {
    trackDownloadSuccess,
    trackDownloadError,
  };
};
